/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BroadcastAlertTargetDto
 */
export interface BroadcastAlertTargetDto {
    /**
     * Explicit shop list (myshopify domains). When set, ONLY these shops are considered — use it to rehearse a broadcast on your own dev shop before sending it wide. Unknown domains are reported back as `unmatchedShopDomains` rather than failing the request. Subscription filters below still apply on top.
     * @type {Array<string>}
     * @memberof BroadcastAlertTargetDto
     */
    'shopDomains'?: Array<string>;
    /**
     * Only shops whose AppSubscription is in one of these states. Omit for any state.
     * @type {Array<string>}
     * @memberof BroadcastAlertTargetDto
     */
    'subscriptionStatuses'?: Array<BroadcastAlertTargetDtoSubscriptionStatusesEnum>;
    /**
     * Only shops on one of these pricing tiers. Omit for any tier.
     * @type {Array<string>}
     * @memberof BroadcastAlertTargetDto
     */
    'subscriptionTiers'?: Array<BroadcastAlertTargetDtoSubscriptionTiersEnum>;
    /**
     * When a status/tier filter is set, also include shops that have NO AppSubscription row at all (installed but never subscribed). Ignored when no subscription filter is set — those shops are included anyway. Defaults to false.
     * @type {boolean}
     * @memberof BroadcastAlertTargetDto
     */
    'includeShopsWithoutSubscription'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum BroadcastAlertTargetDtoSubscriptionStatusesEnum {
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Cancelled = 'CANCELLED',
    Declined = 'DECLINED',
    Expired = 'EXPIRED',
    Frozen = 'FROZEN'
}
/**
    * @export
    * @enum {string}
    */
export enum BroadcastAlertTargetDtoSubscriptionTiersEnum {
    Starter = 'STARTER',
    Professional = 'PROFESSIONAL',
    Business = 'BUSINESS',
    Enterprise = 'ENTERPRISE'
}


